import { useParams } from 'react-router-dom';
import { useDbInvoiceById } from '../../base/useDbReports';
import { DisplayInvoice } from './DisplayInvoice';

export function ViewInvoiceById() {
    const { invoiceId } = useParams();
    const { invoice, products, isLoading, error } = useDbInvoiceById(invoiceId);

    if (!invoiceId) {
        return (
            <div className='p-4 text-center text-gray-500 text-lg'>
                Invoice ID is missing.
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className='p-4 text-center text-gray-500 text-lg'>
                Loading invoice...
            </div>
        );
    }

    if (error || !invoice) {
        return (
            <div className='p-4 text-center text-gray-500 text-lg'>
                {error || 'Invoice not found.'}
            </div>
        );
    }

    return (
        <div className='p-4'>
            <DisplayInvoice invoice={invoice} products={products} />
        </div>
    );
}